import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Pipe({ name: 'certificationExpirationDisabled' })
export class CertificateExpirationDisabledPipe implements PipeTransform {
    transform(expirationDate: Moment): boolean {
        const today = moment().startOf('day');

        const duration = moment.duration(today.diff(expirationDate));
        const durationInMonths = duration.asMonths();

        if (durationInMonths > 3) {
            return true;
        } else {
            return false;
        }
    }
}
